import { FormHelperText } from '@mui/material';
import { usePhrase } from '@/hooks';
import type { FieldError } from 'react-hook-form';
import { isNumberOrStringNumber } from '@/types';
interface FormErrorTextProps {
    error?: FieldError | null;
}

export const FormErrorText = (props: FormErrorTextProps) => {
    const { t } = usePhrase();
    return (
        <>
            {props.error && props.error?.message && (
                <FormHelperText error data-testid={'errorText'}>
                    {isNumberOrStringNumber(props.error.message)
                        ? t(props.error.message)
                        : props.error.message}
                </FormHelperText>
            )}
        </>
    );
};
